import { ErrorButton } from '@design';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseErrorView } from '../base-error-view/BaseErrorView';
import styles from './ErrorMessageWrapper.module.scss';

type Variant = 'error' | 'empty';

export interface ErrorMessageWrapperProps {
  className?: string;
  variant?: Variant;
  displayIcon?: boolean;
  title?: string;
  subTitle?: string;
  showBorder?: boolean;
  buttonProps?: ErrorButton;
}

export const ErrorMessageWrapper = ({
  className,
  displayIcon,
  variant = 'error',
  title,
  subTitle,
  showBorder = true,
  buttonProps,
  ...rest
}: ErrorMessageWrapperProps) => {
  const { t } = useTranslation(['widget', 'common']);

  const messageComponent = {
    error: (
      <BaseErrorView
        title={title}
        subtitle={subTitle}
        displayIcon={displayIcon ? 'error' : undefined}
        buttonProps={buttonProps}
      />
    ),
    empty: (
      <BaseErrorView
        displayIcon={displayIcon ? 'empty' : undefined}
        title={title ?? t('widget:empty.titleEmpty')}
        subtitle={subTitle ?? t('widget:empty.subtitleEmpty')}
        buttonProps={buttonProps}
      />
    ),
  };

  return (
    <div
      {...rest}
      className={clsx(styles.styledErrorMessageRoot, className, {
        [styles.showBorder]: showBorder,
      })}
    >
      {messageComponent[variant]}
    </div>
  );
};
